import { render, staticRenderFns } from "./sorter.vue?vue&type=template&id=651927b4&"
import script from "./sorter.vue?vue&type=script&lang=js&"
export * from "./sorter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports